<div #toastElement
     class="toast-modal"
     [class.show]="isVisible"
     [class.success]="type === 'success'"
     [class.danger]="type === 'danger'"
     [ngStyle]="{ 'width': toastWidth }"
     role="alert"
     aria-live="assertive"
     aria-atomic="true">

    <div class="toast-content">
        <img [src]="type === 'success' ? 'assets/img/check-circle.svg' : 'assets/img/exclamation-chat.svg'"
             alt="Toast icon" width="24">
        <div>{{ message }}</div>
    </div>

    <button type="button"
            class="btn-close"
            (click)="hideToast()"
            aria-label="Close toast">
        <img src="assets/img/xmark-circle.svg" />
    </button>
</div>
